import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Typography, Box } from '@material-ui/core';
import { BackIcon } from 'components/Icons';
import api from 'api/Associado/duvidas';
import Context from 'components/DuvidasFrequentes/Context';
import useStyle from './style';

export default function () {
  const { t } = useTranslation();
  const classes = useStyle();
  const { perguntaAtual, list, atualizarPergunta, cpf } = useContext(Context);

  useEffect(() => {
    const marcarComoLido = async () => {
      if (perguntaAtual?.resposta && !perguntaAtual.lido) {
        const { response } = await api.lido(perguntaAtual.idPergunta);
        if (response && response.status === 200) {
          atualizarPergunta({
            ...perguntaAtual,
            lido: true,
          });
        }
      }
    };
    perguntaAtual?.cpfUsuario === cpf && marcarComoLido();
  }, [perguntaAtual, atualizarPergunta, cpf]);

  if (!perguntaAtual) return null;

  return (
    <Box className={classes.root}>
      <Box className={classes.toolbar}>
        <Button
          variant="text"
          startIcon={<BackIcon />}
          className={classes.back}
          onClick={list}
        >
          <Typography variant="body1">{t('back')}</Typography>
        </Button>
      </Box>
      <Divider />
      <Box component="section" className={classes.content}>
        <Typography
          variant="body1"
          component="h3"
          className={[classes.text, classes.question].join(' ').trim()}
        >
          <strong>{t('AssembleiaAssociadoRoute.faq.perguntaLabel')}</strong>
          <br />
          {perguntaAtual.pergunta}
        </Typography>
        <Typography variant="body1" component="p" className={classes.text}>
          <strong>{t('AssembleiaAssociadoRoute.faq.respostaLabel')}</strong>
          <br />
          {perguntaAtual.resposta || t(`AssembleiaAssociadoRoute.faq.respostaAutomatica`)}
        </Typography>
      </Box>
    </Box>
  );
}
